/**
 * Normalize Laravel JWT token field names across endpoints.
 * Admin login: access_token | Refresh / loyalty: token
 */
export function extractAccessToken(payload) {
  if (!payload || typeof payload !== 'object') {
    return null;
  }
  return payload.access_token ?? payload.token ?? null;
}
